module.exports = __webpack_public_path__ + "media/wrong-answer.1506875c.mp3";